import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

import { UserMemoModel, UserModel } from '../../models/models';
import { ConfigurationProvider, UserMemoProvider } from '../../providers/providers';

@Component({
  selector: 'page-memo-edit',
  templateUrl: 'memo-edit.html',
})
export class MemoEditPage {
  item: UserMemoModel;
  user: UserModel;

  constructor(
    private config: ConfigurationProvider,
    private userMemoProvider: UserMemoProvider,
    private params: NavParams,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      name: item.Name
    });
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');
      this.item.UserId = this.user._id;
      // save item
      this.userMemoProvider.Save(this.item).then((res: UserMemoModel) => {
        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res);
      });
    }
  }

  formIsValid() {
    if (!this.item.Name) {
      this.config.showAlert('Error', 'Must enter a Name.');
      return false;
    }
    else if (!this.item.Memo) {
      this.config.showAlert('Error', 'Must enter a Memo.');
      return false;
    }

    return true;
  }

  ionViewWillLoad() {
    this.item = this.params.get('item');
    this.user = this.params.get('user');
  }

}



// WEBPACK FOOTER //
// ./src/pages/memo/memo-edit.ts